import "./Overlay.scss"; // CSS for styling the overlay

const Overlay = ({ message }) => {
  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="loading-spinner"></div>
        <p>{message || "Checking user details..."}</p>
      </div>
    </div>
  );
};

export default Overlay;
